// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Customer 360 chrome — ported for client portal workspaces */

.customer360-console {
  --customer360-muted: #6c757d;
  --customer360-card-bg: #ffffff;
  --customer360-card-border: #dee2e6;
}

:root[data-theme="dark"] .customer360-console {
  --customer360-muted: #9ca3af;
  --customer360-card-bg: #1f1f1f;
  --customer360-card-border: #2b2f33;
}

.customer360-view {
  clear: both;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 0.5rem 0 15px;
  margin: 0;
}

main.container > .row > .col .customer360-view {
  clear: none;
}

main.container > .row > .col {
  min-width: 0;
  max-width: 100%;
}

.customer360-muted {
  color: var(--customer360-muted, #6c757d);
}

.customer360-monitoring-card {
  background: var(--customer360-card-bg);
  border: 1px solid var(--customer360-card-border);
  border-radius: 0.5rem;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
}

.customer360-monitoring-card__toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.customer360-view__header {
  margin-bottom: 0.75rem;
}

.customer360-view__title {
  margin: 0;
  color: inherit;
}

.customer360-snapshot {
  overflow: hidden;
  padding: 0;
}

.customer360-snapshot__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--customer360-card-border);
  background: linear-gradient(180deg, rgba(13, 110, 253, 0.06) 0%, transparent 100%);
}

.customer360-snapshot__title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.25rem;
}

.customer360-snapshot__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.35rem;
  background: rgba(13, 110, 253, 0.12);
  color: #0d6efd;
  font-size: 0.9rem;
}

.customer360-snapshot__title {
  font-weight: 600;
  color: inherit;
}

.customer360-snapshot__subtitle {
  font-size: 0.85rem;
  color: var(--customer360-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customer360-snapshot__stat-rows {
  padding: 1rem 1.25rem;
}

.customer360-grid-5 {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.5rem;
  align-items: stretch;
}

.customer360-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem;
  align-items: stretch;
}

.customer360-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  align-items: stretch;
}

.customer360-snapshot__stat {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  min-height: 4.25rem;
  text-align: left;
  padding: 0.65rem 0.75rem;
  border: 1px solid var(--customer360-card-border);
  border-radius: 0.35rem;
  background: transparent;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.customer360-snapshot__stat:hover,
.customer360-snapshot__stat.is-active {
  border-color: #0d6efd;
  background: rgba(13, 110, 253, 0.06);
}

.customer360-snapshot__stat--static {
  cursor: default;
}

.customer360-snapshot__stat--static:hover {
  border-color: var(--customer360-card-border);
  background: transparent;
}

.customer360-snapshot__stat-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--customer360-muted);
  margin-bottom: 0.25rem;
}

.customer360-snapshot__stat-value {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.2;
  color: inherit;
  word-break: break-word;
}

.customer360-provision-actions-card {
  padding: 0;
  overflow: hidden;
}

.customer360-provision-actions-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1rem 1.25rem 0.75rem;
  border-bottom: 1px solid var(--customer360-card-border);
}

.customer360-provision-actions-card__title {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--customer360-muted);
}

.customer360-provision-actions-card__body {
  padding: 0.75rem 1.25rem 1rem;
}

.customer360-provision-actions {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.5rem;
}

.customer360-provision-actions__btn {
  white-space: normal;
  text-align: center;
  padding: 0.5rem 0.35rem;
  line-height: 1.25;
  width: 100%;
}

/* Match Admin 360 action pills — 5 equal columns */
.ticket360-actions .ticket360-actions__pills {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.5rem;
  align-items: stretch;
}

.ticket360-actions .ticket360-actions__btn {
  width: 100%;
  white-space: normal;
  text-align: center;
  padding: 0.5rem 0.35rem;
  line-height: 1.25;
  min-width: 0;
}

.ticket360-actions.customer360-provision-actions-card {
  overflow: visible;
}

@media (max-width: 991.98px) {
  .customer360-provision-actions,
  .ticket360-actions .ticket360-actions__pills {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-secondary {
  border-color: #adb5bd;
  color: #e9ecef;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-secondary:hover,
:root[data-theme="dark"] .ticket360-actions .btn-outline-secondary:focus {
  background-color: #232323;
  border-color: #e9ecef;
  color: #e9ecef;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-primary {
  border-color: #4a9eff;
  color: #7eb6ff;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-primary:hover,
:root[data-theme="dark"] .ticket360-actions .btn-outline-primary:focus {
  background-color: rgba(74, 158, 255, 0.15);
  border-color: #4a9eff;
  color: #b3d4ff;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-danger {
  border-color: #ff6b7a;
  color: #ff8a94;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-danger:hover,
:root[data-theme="dark"] .ticket360-actions .btn-outline-danger:focus {
  background-color: rgba(255, 77, 90, 0.15);
  border-color: #ff6b7a;
  color: #ffb3ba;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-info {
  border-color: #5bc0de;
  color: #7dd3f0;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-dark {
  border-color: #adb5bd;
  color: #e9ecef;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-dark:hover,
:root[data-theme="dark"] .ticket360-actions .btn-outline-dark:focus {
  background-color: #232323;
  border-color: #e9ecef;
  color: #e9ecef;
}

:root[data-theme="dark"] .ticket360-actions .btn-outline-success {
  border-color: #5cb85c;
  color: #7dce7d;
}

.customer360-tabpanel {
  min-width: 0;
}

.portal360-thread {
  max-height: 420px;
  overflow-y: auto;
}

.portal360-thread-item {
  border-bottom: 1px solid var(--customer360-card-border);
  padding: 0.75rem 0;
}

.portal360-thread-item:last-child {
  border-bottom: none;
}

.portal360-composer textarea {
  min-height: 90px;
}

@media (max-width: 991.98px) {
  .customer360-grid-5,
  .customer360-grid-4,
  .customer360-grid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .customer360-snapshot__subtitle {
    white-space: normal;
  }
}

:root[data-theme="dark"] .customer360-snapshot__header {
  background: linear-gradient(180deg, rgba(13, 110, 253, 0.12) 0%, transparent 100%);
}

:root[data-theme="dark"] .customer360-snapshot__icon {
  background: rgba(13, 110, 253, 0.2);
}

:root[data-theme="dark"] .customer360-snapshot__stat {
  border-color: var(--customer360-card-border);
}

/* Tabs — dark mode (match Admin tab-bar) */
:root[data-theme="dark"] .customer360-console .tab-bar .nav-tabs,
:root[data-theme="dark"] .tab-bar.customer360-console .nav-tabs {
  border-bottom-color: #2b2f33;
}

:root[data-theme="dark"] .customer360-console .tab-bar .nav-tabs .nav-link,
:root[data-theme="dark"] .tab-bar.customer360-console .nav-tabs .nav-link {
  color: #adb5bd;
  background-color: transparent;
  border-color: transparent transparent #2b2f33;
}

:root[data-theme="dark"] .customer360-console .tab-bar .nav-tabs .nav-link:hover,
:root[data-theme="dark"] .customer360-console .tab-bar .nav-tabs .nav-link:focus,
:root[data-theme="dark"] .tab-bar.customer360-console .nav-tabs .nav-link:hover,
:root[data-theme="dark"] .tab-bar.customer360-console .nav-tabs .nav-link:focus {
  color: #e9ecef;
  border-color: #2b2f33 #2b2f33 transparent;
  background-color: rgba(255, 255, 255, 0.04);
}

:root[data-theme="dark"] .customer360-console .tab-bar .nav-tabs .nav-link.active,
:root[data-theme="dark"] .tab-bar.customer360-console .nav-tabs .nav-link.active {
  color: #e9ecef;
  background-color: #1f1f1f;
  border-color: #2b2f33 #2b2f33 #1f1f1f;
}

/* Breadcrumbs */
.mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {
  content: "›";
}

.mboss-breadcrumbs .breadcrumb-item.active {
  color: var(--customer360-muted, #6c757d);
}

.mboss-breadcrumbs .breadcrumb-item a,
.mboss-breadcrumbs .breadcrumb-item a:hover,
.mboss-breadcrumbs .breadcrumb-item a:focus {
  text-decoration: none;
}

:root[data-theme="dark"] .mboss-breadcrumbs .breadcrumb-item a {
  color: #7eb6ff;
}

:root[data-theme="dark"] .mboss-breadcrumbs .breadcrumb-item a:hover,
:root[data-theme="dark"] .mboss-breadcrumbs .breadcrumb-item a:focus {
  color: #b3d4ff;
}

:root[data-theme="dark"] .mboss-breadcrumbs .breadcrumb-item.active {
  color: #adb5bd;
}

:root[data-theme="dark"] .mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/platform/workspace360/customer360.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,uDAAuD;EACvD,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,gDAAgD;EAChD,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yCAAyC;EACzC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,2CAA2C;AAC3C;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;;;EAIE,cAAc;EACd,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Admin Customer 360 chrome — ported for client portal workspaces */\n\n.customer360-console {\n  --customer360-muted: #6c757d;\n  --customer360-card-bg: #ffffff;\n  --customer360-card-border: #dee2e6;\n}\n\n:root[data-theme=\"dark\"] .customer360-console {\n  --customer360-muted: #9ca3af;\n  --customer360-card-bg: #1f1f1f;\n  --customer360-card-border: #2b2f33;\n}\n\n.customer360-view {\n  clear: both;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 0.5rem 0 15px;\n  margin: 0;\n}\n\nmain.container > .row > .col .customer360-view {\n  clear: none;\n}\n\nmain.container > .row > .col {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.customer360-muted {\n  color: var(--customer360-muted, #6c757d);\n}\n\n.customer360-monitoring-card {\n  background: var(--customer360-card-bg);\n  border: 1px solid var(--customer360-card-border);\n  border-radius: 0.5rem;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.customer360-monitoring-card__toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.customer360-view__header {\n  margin-bottom: 0.75rem;\n}\n\n.customer360-view__title {\n  margin: 0;\n  color: inherit;\n}\n\n.customer360-snapshot {\n  overflow: hidden;\n  padding: 0;\n}\n\n.customer360-snapshot__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--customer360-card-border);\n  background: linear-gradient(180deg, rgba(13, 110, 253, 0.06) 0%, transparent 100%);\n}\n\n.customer360-snapshot__title-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.25rem;\n}\n\n.customer360-snapshot__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 0.35rem;\n  background: rgba(13, 110, 253, 0.12);\n  color: #0d6efd;\n  font-size: 0.9rem;\n}\n\n.customer360-snapshot__title {\n  font-weight: 600;\n  color: inherit;\n}\n\n.customer360-snapshot__subtitle {\n  font-size: 0.85rem;\n  color: var(--customer360-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.customer360-snapshot__stat-rows {\n  padding: 1rem 1.25rem;\n}\n\n.customer360-grid-5 {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.customer360-grid-4 {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.customer360-grid-3 {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.customer360-snapshot__stat {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100%;\n  min-height: 4.25rem;\n  text-align: left;\n  padding: 0.65rem 0.75rem;\n  border: 1px solid var(--customer360-card-border);\n  border-radius: 0.35rem;\n  background: transparent;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.customer360-snapshot__stat:hover,\n.customer360-snapshot__stat.is-active {\n  border-color: #0d6efd;\n  background: rgba(13, 110, 253, 0.06);\n}\n\n.customer360-snapshot__stat--static {\n  cursor: default;\n}\n\n.customer360-snapshot__stat--static:hover {\n  border-color: var(--customer360-card-border);\n  background: transparent;\n}\n\n.customer360-snapshot__stat-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--customer360-muted);\n  margin-bottom: 0.25rem;\n}\n\n.customer360-snapshot__stat-value {\n  font-size: 1.1rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: inherit;\n  word-break: break-word;\n}\n\n.customer360-provision-actions-card {\n  padding: 0;\n  overflow: hidden;\n}\n\n.customer360-provision-actions-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem 0.75rem;\n  border-bottom: 1px solid var(--customer360-card-border);\n}\n\n.customer360-provision-actions-card__title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: var(--customer360-muted);\n}\n\n.customer360-provision-actions-card__body {\n  padding: 0.75rem 1.25rem 1rem;\n}\n\n.customer360-provision-actions {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.5rem;\n}\n\n.customer360-provision-actions__btn {\n  white-space: normal;\n  text-align: center;\n  padding: 0.5rem 0.35rem;\n  line-height: 1.25;\n  width: 100%;\n}\n\n/* Match Admin 360 action pills — 5 equal columns */\n.ticket360-actions .ticket360-actions__pills {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.ticket360-actions .ticket360-actions__btn {\n  width: 100%;\n  white-space: normal;\n  text-align: center;\n  padding: 0.5rem 0.35rem;\n  line-height: 1.25;\n  min-width: 0;\n}\n\n.ticket360-actions.customer360-provision-actions-card {\n  overflow: visible;\n}\n\n@media (max-width: 991.98px) {\n  .customer360-provision-actions,\n  .ticket360-actions .ticket360-actions__pills {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-secondary {\n  border-color: #adb5bd;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-secondary:hover,\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-secondary:focus {\n  background-color: #232323;\n  border-color: #e9ecef;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-primary {\n  border-color: #4a9eff;\n  color: #7eb6ff;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-primary:hover,\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-primary:focus {\n  background-color: rgba(74, 158, 255, 0.15);\n  border-color: #4a9eff;\n  color: #b3d4ff;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-danger {\n  border-color: #ff6b7a;\n  color: #ff8a94;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-danger:hover,\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-danger:focus {\n  background-color: rgba(255, 77, 90, 0.15);\n  border-color: #ff6b7a;\n  color: #ffb3ba;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-info {\n  border-color: #5bc0de;\n  color: #7dd3f0;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-dark {\n  border-color: #adb5bd;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-dark:hover,\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-dark:focus {\n  background-color: #232323;\n  border-color: #e9ecef;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .ticket360-actions .btn-outline-success {\n  border-color: #5cb85c;\n  color: #7dce7d;\n}\n\n.customer360-tabpanel {\n  min-width: 0;\n}\n\n.portal360-thread {\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n.portal360-thread-item {\n  border-bottom: 1px solid var(--customer360-card-border);\n  padding: 0.75rem 0;\n}\n\n.portal360-thread-item:last-child {\n  border-bottom: none;\n}\n\n.portal360-composer textarea {\n  min-height: 90px;\n}\n\n@media (max-width: 991.98px) {\n  .customer360-grid-5,\n  .customer360-grid-4,\n  .customer360-grid-3 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .customer360-snapshot__subtitle {\n    white-space: normal;\n  }\n}\n\n:root[data-theme=\"dark\"] .customer360-snapshot__header {\n  background: linear-gradient(180deg, rgba(13, 110, 253, 0.12) 0%, transparent 100%);\n}\n\n:root[data-theme=\"dark\"] .customer360-snapshot__icon {\n  background: rgba(13, 110, 253, 0.2);\n}\n\n:root[data-theme=\"dark\"] .customer360-snapshot__stat {\n  border-color: var(--customer360-card-border);\n}\n\n/* Tabs — dark mode (match Admin tab-bar) */\n:root[data-theme=\"dark\"] .customer360-console .tab-bar .nav-tabs,\n:root[data-theme=\"dark\"] .tab-bar.customer360-console .nav-tabs {\n  border-bottom-color: #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .customer360-console .tab-bar .nav-tabs .nav-link,\n:root[data-theme=\"dark\"] .tab-bar.customer360-console .nav-tabs .nav-link {\n  color: #adb5bd;\n  background-color: transparent;\n  border-color: transparent transparent #2b2f33;\n}\n\n:root[data-theme=\"dark\"] .customer360-console .tab-bar .nav-tabs .nav-link:hover,\n:root[data-theme=\"dark\"] .customer360-console .tab-bar .nav-tabs .nav-link:focus,\n:root[data-theme=\"dark\"] .tab-bar.customer360-console .nav-tabs .nav-link:hover,\n:root[data-theme=\"dark\"] .tab-bar.customer360-console .nav-tabs .nav-link:focus {\n  color: #e9ecef;\n  border-color: #2b2f33 #2b2f33 transparent;\n  background-color: rgba(255, 255, 255, 0.04);\n}\n\n:root[data-theme=\"dark\"] .customer360-console .tab-bar .nav-tabs .nav-link.active,\n:root[data-theme=\"dark\"] .tab-bar.customer360-console .nav-tabs .nav-link.active {\n  color: #e9ecef;\n  background-color: #1f1f1f;\n  border-color: #2b2f33 #2b2f33 #1f1f1f;\n}\n\n/* Breadcrumbs */\n.mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {\n  content: \"›\";\n}\n\n.mboss-breadcrumbs .breadcrumb-item.active {\n  color: var(--customer360-muted, #6c757d);\n}\n\n.mboss-breadcrumbs .breadcrumb-item a,\n.mboss-breadcrumbs .breadcrumb-item a:hover,\n.mboss-breadcrumbs .breadcrumb-item a:focus {\n  text-decoration: none;\n}\n\n:root[data-theme=\"dark\"] .mboss-breadcrumbs .breadcrumb-item a {\n  color: #7eb6ff;\n}\n\n:root[data-theme=\"dark\"] .mboss-breadcrumbs .breadcrumb-item a:hover,\n:root[data-theme=\"dark\"] .mboss-breadcrumbs .breadcrumb-item a:focus {\n  color: #b3d4ff;\n}\n\n:root[data-theme=\"dark\"] .mboss-breadcrumbs .breadcrumb-item.active {\n  color: #adb5bd;\n}\n\n:root[data-theme=\"dark\"] .mboss-breadcrumbs .breadcrumb-item + .breadcrumb-item::before {\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
